import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import FoldersHeader from "components/Folders/FoldersHeader";
import * as folderReducer from "containers/Folders/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as globalReducer from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";

class FoldersHeaderContainer extends React.Component {
  render() {
    const { headerMode } = this.props;

    return headerMode === "OVERVIEW" ? <div /> : <FoldersHeader {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchFolders: () => dispatch(folderReducer.fetchFolders()),
    fetchFolder: (id) => dispatch(folderReducer.fetchFolder(id)),
    setDefaultFolder: (id) => dispatch(folderReducer.setDefaultFolder(id)),
    selectFolder: (id) => dispatch(folderReducer.selectFolder(id)),
    createFolder: (name, collaborators) =>
      dispatch(
        folderReducer.createFolder({
          name,
          collaborators
        })
      ),
    updateProjectFolderId: (projectFolderId) => dispatch(globalReducer.updateProjectFolderId(projectFolderId))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    folders: folderReducer.getFoldersArr(state),
    selectedFolder: folderReducer.getSelectedFolderData(state),
    defaultFolderId: folderReducer.getDefaultFolderId(state),
    users: adminReducer.getUsers(state),
    userName: loginReducer.getUserName(state),
    userId: loginReducer.getUserID(state),
    roles: folderReducer.getRoleOptions(state),
    isTableauMode: globalReducer.getIsTableauMode(state),
    isGoogleMode: globalReducer.getIsGoogleMode(state),
    projectFolderId: globalReducer.getProjectFolderId(state),
    headerMode: viewReducer.getHeaderMode(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(FoldersHeaderContainer);
